import React from 'react';
import styled from 'styled-components';
import { StoreLogo } from '../common';


const Wrapper = styled.div`
    background-color: ${props => props.theme.colors.primary};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 156px;
    width: 100%;
`



export const LoginHeader = () => (
    <Wrapper>        
        <StoreLogo />
    </Wrapper>
)